module.exports = __webpack_public_path__ + "img/3233760.jpg";